<template>
  <AdminJobCategoryList :pk="'SFC-'" :lockedFilters="{ ArticleNumberList: [$route.params.articleNumber] }" hideArticleFilter />
</template>


<script>
import AdminJobCategoryList from "@/views/pim/jobcategory/AdminJobCategoryList.vue";

export default {
  name: "ViewArticleJobCategoryList",
  props: {},
  components: {
    AdminJobCategoryList,
  },

  data() {
    return {};
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss'></style>